import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit, OnDestroy, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessageService } from '../../../shared/services/messages.service';

@Component({
  selector: 'app-message',
  standalone: true,
  imports: [NgFor, NgIf, NgClass],
  templateUrl: './message.component.html'
})
export class MessageComponent implements OnInit, OnDestroy {

  @Input()
  public slug!: any;

  @Input()
  public customClass!: any;

  @ViewChild('marqueeItem')
  public marqueeItem!: ElementRef;

  public messages: any[] = [];
  public allMessages: any[] | any = [];

  public currentMessageIndex: number = 0;
  private _marqueeInterval: any;

  private _dayCheckInterval: any;
  private _currentDay: number;

  private _subscription: Subscription = new Subscription();

  constructor(private _messageService: MessageService<any>,
              private _renderer: Renderer2,
              private _cdr: ChangeDetectorRef) {
    this._currentDay = new Date().getDay();
  }

  ngOnInit() {
    this._getMessages();
    this._startDayCheckInterval();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
    clearInterval(this._marqueeInterval);
    clearInterval(this._dayCheckInterval);
  }

  // Messages
  private async _getMessages(): Promise<any> {
    this._subscription.add(this._messageService.listFiltered('slug', this.slug, '==').subscribe(messages => {
      if (this.messages !== messages) {
        this.allMessages = [];
        this.messages = messages;
        
        this._resetMarqueeRotation();
        this._addMessageRestriction();
      }
    }));
  }

  private _addMessageRestriction(): void {
    this.allMessages = [...this.messages, this._getTimeWithDayInfo()];
    this._resetMarqueeRotation();
    this._cdr.detectChanges();
  }

  // MARQUEE
  private _startMarqueeRotation(): void {
    this._resetAnimation();

    this._marqueeInterval = setTimeout(() => {
      if (this.currentMessageIndex + 1 >= this.allMessages.length) {
        this.currentMessageIndex = 0;
      } else {
        this.currentMessageIndex += 1;
      }

      this._cdr.detectChanges();
      this._startMarqueeRotation();
    }, 8000);
  }

  private _resetMarqueeRotation() {
    clearTimeout(this._marqueeInterval);
    this.currentMessageIndex = 0;
    this._startMarqueeRotation();
  }

  private _resetAnimation(): void {
    if (this.marqueeItem) {
      this._renderer.removeClass(this.marqueeItem.nativeElement, 'ci-panel__marquee-item-animation');
      
      setTimeout(() => {
        this._renderer.addClass(this.marqueeItem.nativeElement, 'ci-panel__marquee-item-animation');
        this._cdr.detectChanges();
      }, 10);
    }
  }

  // CHECK DAY
  private _getTimeWithDayInfo(): any {
    const dayOfWeek = new Date().getDay();
    let message = {
      type: 'warning',
      available: true,
      priority: 3,
      icon: 'bi-megaphone',
      text: ''
    };

    switch (dayOfWeek) {
      case 1: // Lunes
        message.text = "Restricción vehicular placas terminación: 0 y 1.";
        break;
      case 2: // Martes
        message.text = "Restricción vehicular placas terminación: 2 y 3.";
        break;
      case 3: // Miércoles
        message.text = "Restricción vehicular placas terminación: 4 y 5.";
        break;
      case 4: // Jueves
        message.text = "Restricción vehicular placas terminación: 6 y 7.";
        break;
      case 5: // Viernes
        message.text = "Restricción vehicular placas terminación: 8 y 9.";
        break;
      default:
        message.text = "Sin restricción vehicular ¡Feliz fin de semana!";
    }

    return message;
  }

  private _checkDayChange(): void {
    const currentDay = new Date().getDay();
    if (this._currentDay !== currentDay) {
      this._currentDay = currentDay;        
      this.allMessages = [];
      this._addMessageRestriction();
    }
  }

  private _startDayCheckInterval(): void {
    clearInterval(this._dayCheckInterval);

    this._dayCheckInterval = setInterval(() => {
      this._checkDayChange();
    }, 60000);
  }
}
